export const showPreferenceModal = (message) => ({
    type: 'SHOW_PREFERENCE_MODAL',
    payload: message
});

export function resetPreferenceModal() {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'RESET_PREFERENCE_MODAL'
            });
            resolve(true)
        });
    }
};